import {ACTIONS} from './constants'

export const setCourierOrder = (payload) => (dispatch) => {
  dispatch({
    type: ACTIONS.SET_ORDERS,
    orders: payload
  })
}